import { render, staticRenderFns } from "./MentionsLanguage.vue?vue&type=template&id=3a748c72&"
import script from "./MentionsLanguage.vue?vue&type=script&lang=js&"
export * from "./MentionsLanguage.vue?vue&type=script&lang=js&"
import style0 from "./MentionsLanguage.vue?vue&type=style&index=0&id=3a748c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports